export const websiteStrings = {
  campaignCodeInputLabel: 'Har du en kampanjkod?',
  campaignCodeInputPlaceholder: '',
  campaignCodeSubmitLabel: 'Aktivera',
  campaignCodeError: 'är inte en giltig kampanjkod',
  campaignCodeActiveTitle: 'Aktiv kampanjkod',
  campaignCodeRemoveCodeTitle: 'Avaktivera den aktiva kampanjkoden'
};



// WEBPACK FOOTER //
// ./src/constants/websiteStrings.js